import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CarsFormComponent } from './cars-form/cars-form.component';
import { HttpClientModule} from '@angular/common/http';
import {NumberScrollComponent} from './number-scroll/number-scroll.component';
import {MatButtonModule, MatIconModule, MatInputModule, MatSelectModule} from '@angular/material';
import {MatGridListModule} from '@angular/material/typings/grid-list';
import {MatCardModule} from '@angular/material/typings/card';
import {MatStepperModule} from '@angular/material/typings/stepper';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/typings/progress-spinner';
import { DateScrollComponent } from './date-scroll/date-scroll.component';
import { SinistreComponent } from './sinistre/sinistre.component';
import {MatCheckboxModule} from '@angular/material/typings/checkbox';
import { FrenchTextPositionsPipe } from './custom_pipes/french-text-positions.pipe';
import {DatePipe} from '@angular/common';
import { CustomTitleCasePipe } from './custom_pipes/custom-title-case.pipe';
import { FloatScrollComponent } from './float-scroll/float-scroll.component';
import { FloatNumberScrollComponent } from './float-number-scroll/float-number-scroll.component';
import {DeviceDetectorModule} from 'ngx-device-detector';
import {ChargementComponent} from './chargement/chargement.component';
import { CustomLoadingComponent } from './custom-loading/custom-loading.component';

@NgModule({
  declarations: [
    AppComponent,
    CarsFormComponent,
    NumberScrollComponent,
    DateScrollComponent,
    SinistreComponent,
    FrenchTextPositionsPipe,
    CustomTitleCasePipe,
    FloatScrollComponent,
    FloatNumberScrollComponent,
    ChargementComponent,
    CustomLoadingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    FormsModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    DeviceDetectorModule.forRoot(),
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
